import { beginCell, Cell } from 'ton-core';

export interface ProposalConfig {
    minimalExecutionAmount: bigint;
    messagesToSend: Cell[];
    content: Cell;
}

export const proposalConfigToCell = (config: ProposalConfig) => {
    let list = config.messagesToSend.reduce((messages, item) => messages.storeRef(item), beginCell()).endCell();
    return beginCell().storeCoins(config.minimalExecutionAmount).storeRef(list).storeRef(config.content).endCell();
};

export const readProposalConfig = (cell: Cell): ProposalConfig => {
    const sl = cell.asSlice();
    const minimalExecutionAmount = sl.loadCoins();
    const list = sl.loadRef().asSlice();
    const content = sl.loadRef();

    const messagesToSend: Cell[] = [];
    while (list.remainingRefs) {
        messagesToSend.push(list.loadRef());
    }

    return {
        minimalExecutionAmount,
        messagesToSend,
        content,
    };
};
